/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.pricing.categories.controllers', [
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.validate',
  'acme.common.service.permissions',
  'acme.common.factory.notice',
  'acme.view.application.pricing.categories.createModal.controllers'
])

.controller('PricingCategoriesController', ['$scope', '$timeout', 'HelpersService', 'ApiService', 'PermissionsService', 'ValidateService', 'NoticeFactory', '$uibModal', function($scope, $timeout, HelpersService, ApiService, PermissionsService, ValidateService, NoticeFactory, $uibModal) {

    var watchers = {};

    $scope.pricingCategories = {

      createPanelShown: false,
      comboGridShown: false,
      isLoaded: false,
      admissionStatus: 'active',

      createModal: {},

      notice: {},

      model: {
        name: '',
        description: '',
        active: true,
        type: 'Individual',
        displayOrder: 0
      },

      categories: [],
      childQuantities : [],
      edited: {},

      admissionTypes: ['Individual', 'Combo', 'Membership'],

      init: function() {
        $scope.$emit('Application::contentTitleChange', {
          title: 'Ticket Categories',
          buttonRight: {
            label: 'New Category',
            permissions: 'PERSON_TYPES_CREATE',
            action: function() {
              $scope.pricingCategories.add();
            }
          }
        });

        this.getPrices();
        this.notice = new NoticeFactory();
        $scope.$emit('PricingController::sidebarViewChange');

        if(PermissionsService.check('PERSON_TYPES_UPDATE')) {
          $scope.admissionsPricingGrid.columnDefs.push({
            field: 'edit',
            displayName: 'Edit',
            onCellNavClick: function(row, col) {
              $scope.pricingCategories.edit(row.entity.id);
            },
            cellTemplate: '<div class="ui-grid-cell-contents"><a data-ng-if="!row.groupHeader" data-ng-click="grid.appScope.edit(row.entity.id)" role="link">Edit<span class="sr-only"> Price Category</span></a></div>'
          });
        }

        if (PermissionsService.check('PERSON_TYPES_DELETE')) {
          $scope.admissionsPricingGrid.columnDefs.push({
            field: 'action',
            displayName: 'Action',
            onCellNavClick: function(row, col) {
              $scope.pricingCategories.remove(row.entity.id);
            },
            cellTemplate: '<div class="ui-grid-cell-contents"><a data-ng-if="!row.groupHeader" data-ng-click="grid.appScope.toggleStatus(row.entity)" role="button"><span data-ng-if="row.entity.active">Deactivate</span><span data-ng-if="!row.entity.active">Activate</span></a></div>'
          });
        }
        watchers.type = $scope.$watch('pricingCategories.model.type', this.onModelTypeUpdate);
        $scope.$on('destroy', this.onDestroy);

      },

      toggleComboGrid: function() {
        this.comboGridShown = (this.model.type === 'Combo');
      },

      openModal: function() {
        var self = $scope.pricingCategories;

        self.admissionStatus = (self.model.active) ? 'active' : 'deactivated';

        self.createModal = $uibModal.open({
          templateUrl: 'views/application/views/pricing/categories/modals/createCategory.tpl.html',
          size: 'md',
          controller: 'PricingCategoriesCreateModalController',
          resolve: {
            pricingCategory: function() {
              return self.model;
            },

            childrenGrid: function() {
              return $scope.childrenGrid;
            },

            admissionTypes: function() {
              return self.admissionTypes;
            },

            comboGridShown: function() {
              return self.comboGridShown;
            },

            childQuantities: function() {
              return self.childQuantities;
            },

            admissionStatus: function() {
              return self.admissionStatus;
            }

          }
        });
      },

      add: function() {
        var self = $scope.pricingCategories;

        self.resetModel();
        self.openModal();

        self.createModal.result.then(function (model) {
          self.model = model;
          self.create();
        }, function () {
          self.cancel();
        });
      },

      edit: function(id) {
        var self = $scope.pricingCategories,
          selected = self.getCategory(id);

        self.model = {
          id: id,
          name: selected.name,
          description: selected.description,
          active: selected.active,
          type: selected.type,
          displayOrder: selected.displayOrder,
          children: []
        };

        if (selected) {
          $scope.pricingCategories.edited[id] = true;
        }

        if (selected.children != null) {
          self.model.children = selected.children;
        }

        self.setChildQuantities(selected.id);
        self.toggleComboGrid();

        self.openModal();
        self.createModal.result.then(function (model) {
          self.model = model;
          self.update();
        }, function () {
          self.cancel();
        });
      },

      getCategory: function(id) {
        var i, ii,
          r = false;
        // Using closure to access id
        for (i=0,ii=this.categories.length;i<ii;i++) {
          if (this.categories[i].id === id) {
            r = this.categories[i];
            break;
          }
        }

        return r;
      },

      findCategory: function(id) {
        var i, ii,
          r = {};
        // Using closure to access id
        for (i=0,ii=this.categories.length;i<ii;i++) {
          if (this.categories[i].id === id) {
            r.index = i;
            r.category = this.categories[i];
            break;
          }
        }

        return r;
      },

      update: function() {
        var type, item;

        this.notice.hideSuccessMessages();
        this.notice.hideErrorMessages();

        for (type in this.edited) {
          if (this.edited.hasOwnProperty(type)) {
            item = $scope.pricingCategories.findCategory(type);

            if(this.model.id === item.category.id){
              this.updateChildren();
              angular.extend(this.categories[item.index], this.model);
            }

            ApiService.price.types.update(this.categories[item.index]).then(this.success.update, this.error.update);
          }
        }
      },

      create: function() {
        this.notice.hideSuccessMessages();
        this.notice.hideErrorMessages();

        this.updateChildren();

        ApiService.price.types.create(this.model).then(this.success.create, this.error.create);
      },

      remove: function(id) {
        var self = $scope.pricingCategories;
        console.log('PricingCategoriesController::remove', arguments);
        self.notice.hideSuccessMessages();
        self.notice.hideErrorMessages();

        ApiService.price.types.remove(id).then(function(response) {
          var i, ii;
          $scope.pricingCategories.resetModel();

          // Using closure to access id
          for (i=0,ii=$scope.pricingCategories.categories.length;i<ii;i++) {
            if ($scope.pricingCategories.categories[i].id === id) {
              $scope.pricingCategories.categories.splice(i, 1);
              break;
            }
          }
          $scope.pricingCategories.success.remove(response);

        }, self.error.remove);
      },

      toggleStatus: function(item) {
        var self = $scope.pricingCategories;
        var props = Object.assign({}, item);
        self.notice.hideSuccessMessages();
        self.notice.hideErrorMessages();
        props.active = !props.active;
        ApiService.price.types.update(props).then(self.success.update, self.error.update);
      },

      cancel: function() {
        this.notice.hideSuccessMessages();
        this.notice.hideErrorMessages();
        this.resetModel();
      },

      resetModel: function() {
        this.model = {
          id: '',
          name: '',
          description: '',
          active: true,
          type: 'Individual',
          displayOrder: 0,
          children: []
        };
        this.admissionStatus = 'active';
        this.resetChildQuantities();
      },

      hasCategories: function() {
        return (this.categories.length > 0);
      },

      getPrices: function() {
        var props = HelpersService.getPaginator({sortField: 'name', sortDirection: 'asc'});
        props.types = 'all';
        props.inactive = true;
        ApiService.price.types.list(props).then(this.success.getPrices, this.error.getPrices);
      },

      setChildQuantities : function(id) {
        var categoriesNdx,
          currentChild,
          childNdx,
          currentCategory,
          currentQuantity;

        $scope.pricingCategories.childQuantities = [];

        for (categoriesNdx = 0; categoriesNdx < $scope.pricingCategories.categories.length; categoriesNdx++) {
          currentCategory = $scope.pricingCategories.categories[categoriesNdx];
          if (currentCategory.type !== 'Combo') {
            currentQuantity = 0;

            if ($scope.pricingCategories.model.children != null) {
              for (childNdx = 0; childNdx < $scope.pricingCategories.model.children.length; childNdx++) {
                currentChild = $scope.pricingCategories.model.children[childNdx];

                if (currentChild.personTypeId === currentCategory.id) {
                  currentQuantity = currentChild.quantity;
                }
              }
            }

            $scope.pricingCategories.childQuantities.push({
              'id': id,
              'personTypeId': currentCategory.id,
              'name': currentCategory.name,
              'quantity': currentQuantity
            });
          }
        }
      },

      updateChildren : function() {
        var ndx,
          currentChild,
          category;

        if ($scope.pricingCategories.model != null) {
          $scope.pricingCategories.model.children = [];

          if ($scope.pricingCategories.childQuantities != null) {
            for (ndx = 0; ndx < $scope.pricingCategories.childQuantities.length; ndx++) {
              currentChild = $scope.pricingCategories.childQuantities[ndx];
              if (currentChild.quantity > 0) {
                $scope.pricingCategories.model.children.push( {
                  'personTypeId' : currentChild.personTypeId,
                  'quantity' : currentChild.quantity
                });
              }
            }
          }

          category = $scope.pricingCategories.getCategory($scope.pricingCategories.model.id);
          if (category != null) {
            category.children = $scope.pricingCategories.model.children;
          }
        }
      },

      resetChildQuantities : function() {
        var ndx,
          currentCategory;

        $scope.pricingCategories.childQuantities = [];
        for (ndx = 0; ndx < $scope.pricingCategories.categories.length; ndx++) {
          currentCategory = $scope.pricingCategories.categories[ndx];
          if (currentCategory.type !== 'Combo') {
            $scope.pricingCategories.childQuantities.push({
              'personTypeId': currentCategory.id,
              'name': currentCategory.name,
              'quantity': 0
            });
          }
        }
      },

      success: {
        create: function(response) {
          var self = $scope.pricingCategories;

          self.getPrices();
          self.resetModel();

          $scope.$emit('PricingCategoriesController::admissionListUpdate', {
            model: self.categories
          });

          self.notice.showSuccessMessages([{
            message: 'Successfully Added!'
          }]);

          $timeout(function() {
            self.notice.hideSuccessMessages();
          }, 3000);

        },

        update: function(response) {
          var self = $scope.pricingCategories;

          self.edited[response.data.payload.id] = null;
          delete self.edited[response.data.payload.id];

          if (self.model.children != null) {
            self.setChildQuantities(self.model.id);
            self.toggleComboGrid();
          }

          self.getPrices();
          self.resetModel();

          $scope.$emit('PricingCategoriesController::admissionListUpdate', {
            model: self.categories
          });

          self.notice.showSuccessMessages([{
            message: 'Successfully Updated!'
          }]);

          $timeout(function() {
            self.notice.hideSuccessMessages();
          }, 3000);

        },

        remove: function(response) {
          $scope.$emit('PricingCategoriesController::admissionListUpdate', {
            model: $scope.pricingCategories.categories
          });
        },

        getPrices: function(response) {
          var ndx,
            currentCategory;
          console.log('PricingCategoriesController::success::getPrices', response);
          $scope.pricingCategories.categories = response.data.payload.list;
          $scope.pricingCategories.isLoaded = true;

          $scope.$emit('PricingCategoriesController::admissionListUpdate', {
            model: $scope.pricingCategories.categories
          });

          $scope.pricingCategories.childQuantities = [];
          for (ndx = 0; ndx < $scope.pricingCategories.categories.length; ndx++) {
            currentCategory = $scope.pricingCategories.categories[ndx];

            if (currentCategory.type !== 'Combo') {
              $scope.pricingCategories.childQuantities.push({
                'personTypeId': currentCategory.id,
                'name': currentCategory.name,
                'quantity': 0
              });
            }
          }
        }
      },

      error: {
        create: function(response) {
          $scope.pricingCategories.notice.showErrorMessages([{
            message: response.data.error
          }]);
        },

        update: function(response) {
          $scope.pricingCategories.notice.showErrorMessages([{
            message: response.data.error
          }]);
        },

        remove: function(response) {
          $scope.pricingCategories.notice.showErrorMessages([{
            message: response.data.error
          }]);
        },

        getPrices: function(response) {
          $scope.pricingCategories.notice.showErrorMessages([{
            message: response.data.error
          }]);
        }
      },

      onModelTypeUpdate: function(n, o) {
        $scope.pricingCategories.toggleComboGrid();
      },

      onDestroy: function() {
        var i;
        for (i in watchers) {
          if (watchers.hasOwnProperty(i)) {
            watchers[i]();
          }
        }
      }

    };

    $scope.admissionsPricingGrid = {
      enableRowSelection: false,
      paginate: false,
      multiSelect: false,
      enableGrouping: true,
      rowClasses: "{ 'ui-grid-row-header-cell': col.isRowHeader, 'pricing-row': true  }",
      columnDefs: [
        {
          field: 'type',
          displayName: 'Admission Type',
          grouping: { groupPriority: 0 },
          sort: {
            priority: 0,
            direction: 'desc'
          },
          cellTemplate: '<div><div data-ng-if="row.groupHeader" class="ui-grid-cell-contents" title="TOOLTIP">{{COL_FIELD CUSTOM_FILTERS}}</div></div>'
        },
        {
          field: 'name',
          displayName: 'Ticket Category',
          sort: {
            priority: 1,
            direction: 'asc'
          }
        },
        {
          field: 'description',
          displayName: 'Description'
        },
        {
          field: 'active',
          displayName: 'Status',
          cellTemplate: '<div class="ui-grid-cell-contents"><span data-ng-if="!row.groupHeader" data-ng-show="COL_FIELD">Live</span><span data-ng-if="!row.groupHeader" data-ng-hide="COL_FIELD">Deactivated</span></div>'
        }
      ],
      appScopeProvider: {
        edit: $scope.pricingCategories.edit,
        remove: $scope.pricingCategories.remove,
        toggleStatus: $scope.pricingCategories.toggleStatus
      }
    };

    $scope.childrenGrid = {
      multiSelect: false,
      enableRowSelection: false,

      columnDefs: [
        {
          field: 'id',
          displayName: 'ID',
          visible: false
        },
        {
          field: 'personTypeId',
          displayName: 'Person Type ID',
          visible: false
        },
        {
          field: 'name',
          displayName: 'Ticket Category',
          sort: {
            direction: 'asc'
          }
        },
        {
          field: 'quantity',
          displayName: 'Quantity',
          enableCellEdit: true,
          editableCellTemplate: 'common/includes/cellEditorTemplate.tpl.html',
          enableCellEditOnFocus: true
        }
      ]
    };

    $scope.pricingCategories.init();

}]);